import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  add(event) {
    event.preventDefault()

    const entry = document.createElement("div")
    entry.className = "flex items-center gap-2"
    entry.dataset.alternativeSubjectsTarget = "entry"
    entry.innerHTML = `
      <input type="text" name="newsletter_issue[alternative_subjects][]" value=""
        class="block w-full rounded-md border-gray-300 shadow-sm focus:border-ppe focus:ring-ppe sm:text-sm" />
      <button type="button" data-action="alternative-subjects#remove"
        class="text-red-600 hover:text-red-800 text-sm whitespace-nowrap">Usuń</button>
    `
    this.containerTarget.appendChild(entry)
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-alternative-subjects-target='entry']").remove()
  }
}
